import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Col, Row, Modal } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';


const AdminStata = () => {
  const [buses, setBuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedBusId, setSelectedBusId] = useState(null);


  const backend_url = process.env.REACT_APP_BACKEND_URL


  // Function to delete a bus
  const handleDelete = async () => {
    try {
      await axios.delete(`${backend_url}/api/delete-bus/${selectedBusId}`);
      // await axios.delete(`http://localhost:8000/api/delete-bus/${selectedBusId}`);
      // Remove the bus from the state
      setBuses(buses.filter(bus => bus._id !== selectedBusId));
      setIsModalVisible(false); // Close the modal after deletion
    } catch (error) {
      console.error('Error deleting bus:', error);
    }
  };

  // Function to show the confirmation modal
  const showConfirmDelete = (busId) => {
    setSelectedBusId(busId);
    setIsModalVisible(true);
  };



  useEffect(() => {
    // Function to fetch buses
    const fetchBuses = async () => {
      try {
        const response = await axios.get(`${backend_url}/api/get-buses`);
        // const response = await axios.get(`http://localhost:8000/api/get-buses`);
        setBuses(response.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBuses();
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  return (

    <>
      <div className='stat w-full m-0 max-w-8xl border border-gray-500 rounded-lg shadow-md p-4 mx-auto' style={{ maxHeight: '85vh', overflowY: 'auto' }}>
        <p className='bg-gray-200 p-3 text-center text-lg font-semibold rounded-md mb-4'>
          Buses Information
        </p>
        <div className="travelinfo">
          <Row gutter={[16, 16]} className="md:gap-4">
            {buses.map(bus => (
              <Col xs={24} sm={12} md={10} lg={6} key={bus._id} className="mx-auto my-4">
                <div className="info p-4 bg-white rounded-lg border border-gray-200 flex flex-col justify-between h-full shadow-lg hover:shadow-xl transition-shadow duration-300">
                  {/* Bus Header */}
                  <div className="relative mb-4 flex items-center justify-between">
                    <span className="name text-lg md:text-xl font-bold truncate">Bus Number: {bus.number}</span>
                    <DeleteOutlined
                      className="text-red-500 cursor-pointer"
                      onClick={() => showConfirmDelete(bus._id)}
                    />
                  </div>

                  {/* Bus Details */}
                  <div className="text-gray-700 space-y-2">
                    <div className="name text-base md:text-lg font-semibold">{bus.name}</div>
                    <div className="timing text-sm">{bus.timing}</div>
                    <div className="seats text-sm">Seats: {bus.seats}</div>
                    <div className="fromStation text-sm">From: {bus.fromStation}</div>
                    <div className="toStation text-sm">To: {bus.toStation}</div>
                    <div className="fare text-sm">Fare: {bus.fare}</div>

                    {bus.inBetweenStations.length > 0 && (
                      <div className="inBetweenStations text-sm mt-2">
                        <strong>In Between Stations:</strong>
                        <ul className="list-disc list-inside">
                          {bus.inBetweenStations.map((station, index) => (
                            <li key={index}>{station}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        {/* Confirmation Modal */}
        <Modal
          title="Confirm Deletion"
          visible={isModalVisible}
          onOk={handleDelete}
          onCancel={() => setIsModalVisible(false)}
          okText="Yes"
          cancelText="No"
        >
          <p>Are you sure you want to delete this bus?</p>
        </Modal>
      </div>




    </>


  );
};

export default AdminStata;
